package ir.yusefpasha.models

import org.jetbrains.compose.web.css.CSSSizeValue
import org.jetbrains.compose.web.css.CSSUnit
import org.jetbrains.compose.web.css.percent

enum class Skill(
    val title: String,
    val percentage:CSSSizeValue<CSSUnit.percent>
) {
    Creative(title = "Creative", percentage = 80.percent),
    Accountable(title = "Accountable", percentage = 80.percent),
    HardWorking(title = "HardWorking", percentage = 70.percent),
    Value(title = "Value For Money", percentage = 75.percent),
    Delivery(title = "On-Time Delivery", percentage = 80.percent),
}